module.exports = __webpack_public_path__ + "img/slide-example.2a2615f1.png";